import type { SVGProps } from "react";

// My Page 전용 아이콘 (Figma ver.7 SVG 수집분 · 공용 nv-icons.tsx 는 건드리지 않아요).
// 별(북마크됨 · 안됨)은 Icon / Star · 북마크됨 (847:47810) · Icon / Star (847:57548), 휴지통은 trash (외부) 847:47903,
// 잠금은 Icon / Lock 14 (847:51225), 닫기는 x (Lucide · 닫기) 24 (847:44787), 시계 · 메일은 (외부) 847:51675 · 847:51681.
type IconProps = Omit<SVGProps<SVGSVGElement>, "width" | "height"> & { size?: number };

// 북마크됨: 주황 채움 + 1.6 선 (#FD5108)
function NvStarFilledIcon({ size = 21, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" fill="none" aria-hidden {...props}>
      <path
        d="M10.5 1.75L13.2038 7.2275L19.25 8.11125L14.875 12.3725L15.9075 18.3925L10.5 15.5487L5.0925 18.3925L6.125 12.3725L1.75 8.11125L7.79625 7.2275L10.5 1.75Z"
        fill="#FD5108"
        stroke="#FD5108"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// 북마크 안 됨: PwC 별 윤곽 (#1A1C21 35%)
function NvStarOutlineIcon({ size = 21, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" fill="none" aria-hidden {...props}>
      <path
        d="M4.90169 9.1875H9.27964L10.5 5.49509L11.7204 9.1875H16.0983L12.416 12.2964L14.0929 16.1513L12.7845 15.2864L11.6568 16.1144L17.0625 19.6875L14.0093 12.6688L19.6875 7.875H12.6688L10.5 1.3125L8.33116 7.875H1.3125L6.9907 12.6688L3.9375 19.6875L11.6127 14.5119L10.5 13.7765L6.9071 16.1513L8.58401 12.2964L4.90169 9.1875Z"
        fill="#1A1C21"
        fillOpacity={0.35}
      />
    </svg>
  );
}

function NvTrashIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden {...props}>
      <g stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
        <path d="M2.25 4.5H15.75" />
        <path d="M14.25 4.5V15C14.25 15.75 13.5 16.5 12.75 16.5H5.25C4.5 16.5 3.75 15.75 3.75 15V4.5" />
        <path d="M6 4.5V3C6 2.25 6.75 1.5 7.5 1.5H10.5C11.25 1.5 12 2.25 12 3V4.5" />
        <path d="M7.5 8.25V12.75" />
        <path d="M10.5 8.25V12.75" />
      </g>
    </svg>
  );
}

// 정보 수정의 읽기 전용 칸 오른쪽 (#9AA0A6)
function NvLockSmallIcon({ size = 14, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden {...props}>
      <g stroke="#9AA0A6" strokeWidth={1.16667} strokeLinecap="round" strokeLinejoin="round">
        <path d="M11.0833 6.41602H2.91667C2.27233 6.41602 1.75 6.93835 1.75 7.58268V11.666C1.75 12.3103 2.27233 12.8327 2.91667 12.8327H11.0833C11.7277 12.8327 12.25 12.3103 12.25 11.666V7.58268C12.25 6.93835 11.7277 6.41602 11.0833 6.41602Z" />
        <path d="M4.08594 6.41602V4.08268C4.08594 3.30913 4.39323 2.56727 4.94021 2.02029C5.48719 1.47331 6.22906 1.16602 7.0026 1.16602C7.77615 1.16602 8.51802 1.47331 9.065 2.02029C9.61198 2.56727 9.91927 3.30913 9.91927 4.08268V6.41602" />
      </g>
    </svg>
  );
}

// 팝업 닫기 (Lucide x · 24px · 선 1.8). 06 닫기 아이콘 기준 (637:593)
function NvLucideCloseIcon({ size = 24, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
      <g stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6L6 18" />
        <path d="M6 6L18 18" />
      </g>
    </svg>
  );
}

function NvClockIcon({ size = 24, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
      <g stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
        <path d="M12 6V12L16 14" />
      </g>
    </svg>
  );
}

function NvMailIcon({ size = 14, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden {...props}>
      <g stroke="currentColor" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round">
        <path d="M11.6641 2.33398H2.33073C1.6864 2.33398 1.16406 2.85632 1.16406 3.50065V10.5007C1.16406 11.145 1.6864 11.6673 2.33073 11.6673H11.6641C12.3084 11.6673 12.8307 11.145 12.8307 10.5007V3.50065C12.8307 2.85632 12.3084 2.33398 11.6641 2.33398Z" />
        <path d="M12.8307 4.08398L7.59823 7.40898C7.41814 7.52182 7.20991 7.58166 6.9974 7.58166C6.78488 7.58166 6.57665 7.52182 6.39656 7.40898L1.16406 4.08398" />
      </g>
    </svg>
  );
}

// 비교표 지표 "도입 전 → 도입 후" 화살표 (Lucide arrow · 16px, #A1A8B3)
function NvArrowRightIcon({ size = 16, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
      <g stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <path d="M3.33594 8H12.6693" />
        <path d="M8 3.33301L12.6667 7.99967L8 12.6663" />
      </g>
    </svg>
  );
}

// 비교함 선택 체크 (흰 ✓ · 14px)
function NvCheckSmallIcon({ size = 14, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden {...props}>
      <path d="M12.2499 2.48438L5.62398 10.0988L2.31262 7.03923L1.71875 7.68183L5.69237 11.3532L12.2506 3.81645V2.48493L12.2499 2.48438Z" fill="currentColor" />
    </svg>
  );
}

export {
  NvStarFilledIcon,
  NvStarOutlineIcon,
  NvTrashIcon,
  NvLockSmallIcon,
  NvLucideCloseIcon,
  NvClockIcon,
  NvMailIcon,
  NvArrowRightIcon,
  NvCheckSmallIcon,
};
